// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2tNPx","header":"ReportDetails_header__2Hf7a","title":"ReportDetails_title__7X3sh","left":"ReportDetails_left__2FyBP"};